
// This makes is so the page doesn't flash when it first loads
const mainContent = document.querySelector('html');
mainContent.style.display="none";
document.addEventListener("DOMContentLoaded",function(event) {mainContent.style.display="block"; });

// We create an mutation observer in case a pase adds elements for example if a page has inifnite scroll
const observerOptions = {
    childList:true,
    subtree:true,
};

const mutObserver = new MutationObserver( (a,b) =>{
    loadEffect();

} );
mutObserver.observe( document.querySelector("#MainContent"),observerOptions );



// This function is in charge of getting all of the content from the page and assign and observer to it
// so when the element is on screen this transitions from not visible to visible.
function loadEffect(){
    const sections = document.querySelectorAll('#MainContent section div:not(.first_image,.second_image), #MainContent section div svg');
    // hide all sections
    sections.forEach( (section)=>{
        if(section.style.background == '') section.classList.add("hide-animation");
    } );


    const interObserver = new IntersectionObserver( (entries) =>{
        entries.forEach( (entry)=>{
            // console.log(entry);
            if(entry.isIntersecting){
                entry.target.classList.add("show-animation");
            }
        } )
    } )


    sections.forEach( (elem) => interObserver.observe(elem) );

}




loadEffect();


